import React from 'react'
import { useLocation } from 'react-router-dom'

const footerInfoList = [
  { key: '상호', value: '주식회사 시그마테크놀로지' },
  // { key: '대표자명', value: '정구일' },
  { key: '전화번호', value: '+82 010-9162-3187' },
  { key: '사업자등록번호', value: '815-87-01926' },
  { key: '이메일', value: 'jeong@sigmatechnology.io' },
  { key: '주소', value: '서울특별시 금천구 가산디지털2로 135, 1215~1216호' },
]

export default function Footer() {
  const location = useLocation()
  if (location.pathname === '/contact/qnas') return null
  if (location.pathname === '/contact/qnas/intro') return null
  if (location.pathname === '/recruit') return null
  return (
    <div className='bg-[#0F0F10] w-full sm:h-[215px] z-10 relative'>
      <div className='container py-32 mx-auto'>
        <div className='flex flex-col items-center gap-28'>
          <div className='flex flex-row items-center gap-40 sm:flex-col max-sm:px-5'>
            {/* logo-footer */}
            <div>
              <img src={require('assets/logos/logo-footer.png')} alt='' className='w-[75px]' />
            </div>
            {/* description */}
            <div className='flex-col items-center hidden gap-8 sm:flex'>
              <div className='flex gap-8'>
                {/* 상호 */}
                <div className='flex gap-4'>
                  <p className='text-body3-medium text-sk-info'>상호</p>
                  <p className='text-body3-medium text-sk-disable'>주식회사 시그마테크놀로지</p>
                </div>

                {/* <div className='w-[1px] h-12 bg-[#46474C]'></div>
                <div className='flex gap-4'>
                  <p className='text-body3-medium text-sk-info'>대표자명</p>
                  <p className='text-body3-medium text-sk-disable'>정구일</p>
                </div> */}

                <div className='w-[1px] h-12 bg-[#46474C]'></div>
                {/* 전화번호 */}
                <div className='flex gap-4'>
                  <p className='text-body3-medium text-sk-info'>전화번호</p>
                  <p className='no-underline text-body3-medium text-sk-disable'>
                    +82 010-9162-3187
                  </p>
                </div>
              </div>

              <div className='flex gap-8'>
                {/* 사업자등록번호 */}
                <div className='flex gap-4'>
                  <p className='text-body3-medium text-sk-info'>사업자등록번호</p>
                  <p className='no-underline text-body3-medium text-sk-disable'>815-87-01926</p>
                </div>

                <div className='w-[1px] h-12 bg-[#46474C]'></div>
                {/* 이메일 */}
                <div className='flex gap-4'>
                  <p className='text-body3-medium text-sk-info'>이메일</p>
                  <p className='no-underline text-body3-medium text-sk-disable'>
                    jeong@sigmatechnology.io
                  </p>
                </div>

                <div className='w-[1px] h-12 bg-[#46474C]'></div>
                {/* 주소 */}
                <div className='flex gap-4'>
                  <p className='text-body3-medium text-sk-info'>주소</p>
                  <p className='no-underline text-body3-medium text-sk-disable'>
                    서울특별시 금천구 가산디지털2로 135, 1215~1216호
                  </p>
                </div>
              </div>
            </div>
            <div className='grid grid-cols-1 gap-10 sm:hidden'>
              {footerInfoList.map((info, index) => (
                <div key={index} className='flex gap-4'>
                  <p className='text-body3-medium text-sk-info shrink-0'>{info.key}</p>
                  <p className='text-body3-medium text-sk-disable'>{info.value}</p>
                </div>
              ))}
            </div>
          </div>
          {/* @2024 */}
          <div>
            <p className='text-center text-body3-medium text-sk-info'>
              © 2024. Sigma Technology Inc. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
